import { gql } from 'graphql-request'

export const CHECK_CLIENT_IS_STUCK = gql`
  query CheckClientIsStuck($email: String!) {
    checkClientIsStuck(email: $email)
  }
`
